export default __webpack_public_path__ + "static/media/stethoscope.025c9cbc.svg";